import Vue from 'vue'
import VueRouter from 'vue-router'
// import UploadDocument from "../components/service/UploadDocument.vue"
import DownloadDocument from "../components/service/DownloadDocument.vue"
const DashboardView = () => import('../views/DashboardView.vue')
const DashboardTSAView = () => import('../views/DashboardTSAView.vue')
const MainDashboard = () => import('../components/dashboard/MainDashboard.vue')
const LoginView = () => import('../views/LoginView.vue')
const RegisterView = () => import('../components/login/RegisterOneIDComponent.vue')
const ForgotPasswordView = () => import('../components/login/ForgotPasswordComponent.vue')
const DetailLog = () => import('../components/dashboardTSA/DetailLogTable.vue')
const ServiceTSA = () => import('../components/dashboardTSA/service/UploadDocument.vue')
const DownloadDocumentTSA = () => import('../components/dashboardTSA/service/DownloadDocument.vue')
const TSALog = () => import('../components/dashboardTSA/TSALog.vue')
const ServiceRateTSA = () => import('../components/dashboardTSA/ServiceRate.vue')
const AccountTSA = () => import('../components/dashboardTSA/AccountUser.vue')
const DashboardTSA = () => import('../components/dashboardTSA/DashboardTSA.vue')
const ContactUs = () => import('../components/dashboardTSA/ContactUs.vue')
Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: {
      auth: false,
      title: "Portal",
    },
  },
  {
    path: "/register",
    name: "register",
    component: RegisterView,
    meta: {
      auth: false,
      title: "Register",
    },
  },
  {
    path: "/forgotpassword",
    name: "forgotpassword",
    component: ForgotPasswordView,
    meta: {
      auth: false,
      title: "Forgot Password",
    },
  },
  {
    path: "/",
    name: "standard",
    redirect: { name: "Dashboard" },
    component: MainDashboard,
  },
  {
    path: "/dashboardTSA",
    redirect: { name: "ServiceTSA" },
    component: DashboardTSAView,
    beforeEnter: (to, from, next) => {
      if ( localStorage.getItem("access_token")) { next() } else { next('/login') }
    },
    children: [
      {
        path: "/dashboardTSA/Service",
        name: "ServiceTSA",
        component: ServiceTSA,
        meta: {
          auth: false,
          title: "Service TSA"
        },
      },
      {
        path: "/",
        name: "DashboardTSA",
        component: DashboardTSA,
        meta: {
          auth: false,
          title: "Dashboard TSA"
        },
      },
      {
        path: "/dashboardTSA/contact",
        name: "ContactUs",
        component: ContactUs,
        meta: {
          auth: false,
          title: "Contact Us"
        },
      },
      {
        path: "/dashboardTSA/detail-log",
        name: "DetailLog",
        component: DetailLog,
        meta: {
          auth: false,
          title: "Detail Log"
        },
      },
      {
        path: "/dashboardTSA/tsa-log",
        name: "TSALog",
        component: TSALog,
        meta: {
          auth: false,
          title: "TSA Log"
        },
      },
      {
        path: "/dashboardTSA/downloadDocument",
        name: "DownloadDocumentTSA",
        component: DownloadDocumentTSA,
        meta: {
          auth: false,
          title: "Download"
        },
      },
      {
        path: "/dashboardTSA/service-rate",
        name: "ServiceRateTSA",
        component: ServiceRateTSA,
        meta: {
          auth: false,
          title: "Service Rate"
        },
      },
      {
        path: "/dashboardTSA/account-user",
        name: "AccountTSA",
        component: AccountTSA,
        meta: {
          auth: false,
          title: "Account User"
        },
      },
    ]
  },
  {
    path: "/dashboard",
    redirect: { name: "Dashboard" },
    component: DashboardView,
    children: [
      {
        path: "/",
        name: "Dashboard",
        component: MainDashboard,
        meta: {
          auth: false,
          title: "Dashboard"
        },
      },
      // {
      //   path: "/uploadDocument",
      //   name: "uploadDocument",
      //   component: UploadDocument,
      // },
      {
        path: "/downloadDocument",
        name: "DownloadDocument",
        component: DownloadDocument,
        meta: {
          auth: false,
          title: "Download"
        },
      }
    ]
  },
  
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router;
